export default {
  computed: {
    trainCategories() {
      return this.$store.state.trainCategories.list;
    },
    stations() {
      return this.$store.state.stations.list;
    },
    searchParams() {
      return this.$store.state.search.params;
    },
    searchResults() {
      return this.$store.state.search.results;
    },
    myTickets() {
      return this.$store.state.myTickets.list;
    },
    userSignedIn() {
      return this.$store.getters['user/userSignedIn'];
    },
    userToken() {
      return this.$store.state.user.token;
    },
  },
};
